import type { Template } from "@/types";

export const LA_05_H3_V2: Template[] = [
{
    id: "la-05-h3v2-01",
    name: "LA 01 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 64, y: 48, width: 251, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 48, width: 251, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 763, y: 48, width: 384, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 304, width: 188, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 304, width: 188, height: 125, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-02",
    name: "LA 02 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 87, y: 48, width: 195, height: 123, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 177, width: 195, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 87, y: 307, width: 195, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 289, y: 48, width: 261, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 812, y: 48, width: 287, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-03",
    name: "LA 03 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 61, width: 226, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 234, y: 61, width: 226, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 467, y: 61, width: 267, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 467, y: 241, width: 267, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 61, width: 532, height: 354, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-04",
    name: "LA 04 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 61, width: 532, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 540, y: 61, width: 226, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 774, y: 61, width: 226, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1007, y: 61, width: 267, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1007, y: 241, width: 267, height: 173, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-05",
    name: "LA 05 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 126, y: 42, width: 278, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 126, y: 243, width: 139, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 273, y: 243, width: 278, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 42, width: 139, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 559, y: 42, width: 589, height: 393, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-06",
    name: "LA 06 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 126, y: 42, width: 589, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 243, width: 139, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 42, width: 139, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 870, y: 42, width: 279, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 870, y: 243, width: 279, height: 192, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-07",
    name: "LA 07 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 126, y: 42, width: 589, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 42, width: 279, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 243, width: 279, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1009, y: 42, width: 139, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 243, width: 139, height: 192, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-08",
    name: "LA 08 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 122, width: 319, height: 229, rotation: 0, imageRotation: 0 },
            { id: "2", x: 327, y: 122, width: 142, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 477, y: 122, width: 319, height: 229, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 122, width: 142, height: 229, rotation: 0, imageRotation: 0 },
            { id: "5", x: 953, y: 122, width: 321, height: 229, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-09",
    name: "LA 09 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 122, width: 142, height: 229, rotation: 0, imageRotation: 0 },
            { id: "2", x: 149, y: 122, width: 319, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 476, y: 122, width: 319, height: 229, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 122, width: 321, height: 229, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1132, y: 122, width: 142, height: 229, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h3v2-10",
    name: "LA 10 - H3V2",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 126, y: 42, width: 589, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 42, width: 139, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 243, width: 278, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 870, y: 42, width: 278, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1008, y: 243, width: 139, height: 192, rotation: 0, imageRotation: 0 }
    ],
}
];